import { render, staticRenderFns } from "./timeScreen.vue?vue&type=template&id=12087416&scoped=true&"
import script from "./timeScreen.vue?vue&type=script&lang=js&"
export * from "./timeScreen.vue?vue&type=script&lang=js&"
import style0 from "./timeScreen.vue?vue&type=style&index=0&id=12087416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12087416",
  null
  
)

export default component.exports